import React from "react";

class FileField extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  onChangeHandler(event: any) {
    this.props.input.onChange(event.target.files[0]);
    if (this.props.onChange !== undefined) {
      this.props.onChange(event);
    }
  }

  render() {
    return (
      <input
        id={this.props.id}
        name={this.props.name}
        className={this.props.cssClassName}
        type="file"
        onChange={this.onChangeHandler}
        accept={this.props.allowedMimeTypes}/>
    );
  }
}

export default FileField;
